export default function Wrapper({ children }) {

  return (
    <div className="flex flex-col min-h-screen relative">
      {children}
    </div>
  )
}